export default "__VITE_ASSET__CaUmXx1d__"